var exports = {
  "tz": "MonaFooter__X3jCS8",
  "xA": "Grid__L5tWpK",
  "O5": "CanvasLayer__Yf8E0z",
  "MI": "CanvasPosition__hGPSwO",
  "H4": "Fallback__cuF5Km",
  "aY": "openingComplete__DEthMO",
};

module.exports = exports;
